<template>
  <div class="operators" @mousedown.prevent>
    <template v-for="tool in tools">
      <!-- 分隔符 -->
      <div 
        v-if="tool.type === 'separator'"
        :key="`separator-${tool.name}`"
        class="sep"
      ></div>

      <!-- 下拉菜单类型工具 -->
      <el-dropdown 
        v-else-if="tool.type === 'dropdown'"
        :key="`dropdown-${tool.name}`"
        trigger="click"
        @command="(command) => handleDropdownSelect(tool, command)"
      >
        <div 
          class="operator-item" 
          :class="{ active: isActive(tool.name) }"
        >
          <el-tooltip :content="tool.tooltip" effect="dark" placement="bottom">
            <div class="operator-item">
              <img :src="getIconSrc(tool.icon)" />
              <span>{{ tool.label }}</span>
            </div>
          </el-tooltip>
        </div>
        <el-dropdown-menu slot="dropdown" class="ssml-dropdown-menu">
          <el-dropdown-item 
            v-for="option in tool.options"
            :key="option.id"
            :command="option"
          >
            {{ option.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <!-- 普通插件类型工具 -->
      <div 
        v-else
        :key="`plugin-${tool.name}`"
        :class="{ active: isActive(tool.name) }"
        @click.stop="handleClick(tool)"
      >
        <el-tooltip :content="tool.tooltip" effect="dark" placement="bottom">
          <div class="operator-item">
            <img :src="getIconSrc(tool.icon)" />
            <span>{{ tool.label }}</span>
          </div>
        </el-tooltip>
      </div>
    </template>
  </div>
</template>

<script>
import { Message, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'

export default {
  name: 'SsmlToolbar',

  components: {
    'el-dropdown': Dropdown,
    'el-dropdown-menu': DropdownMenu,
    'el-dropdown-item': DropdownItem
  },

  inject: ['store'],

  props: {
    tools: {
      type: Array,
      required: true
    }
  },

  computed: {
    isFocusInsideEditor() {
      return this.store.state.ssmlEditor.isFocusInsideEditor
    },
    
    savedRange() {
      return this.store.state.ssmlEditor.savedRange
    }
  },

  methods: {
    handleClick(tool) {
      // 只处理非下拉菜单类型的工具点击
      if (tool.type === 'dropdown') {
        return
      }

      if (tool.needFocus && !this.isFocusInsideEditor) {
        Message.warning('请将光标移至编辑器内')
        return
      }

      if (tool.needSelection && !this.savedRange) {
        Message.warning('请先选择要操作的文本')
        return
      }

      this.$emit('tool-click', tool)
    },

    handleDropdownSelect(tool, option) {
      // 获取编辑器状态
      const editor = document.querySelector('#article')
      const isEditorFocused = this.isFocusInsideEditor
      const savedRange = this.store.state.ssmlEditor.savedRange

      // 如果编辑器未获得焦点
      if (!isEditorFocused) {
        if (editor) {
          // 1. 先让编辑器获得焦点
          editor.focus()
          
          // 2. 恢复之前保存的选区
          if (savedRange) {
            const selection = window.getSelection()
            selection.removeAllRanges()
            selection.addRange(savedRange)
          }

          // 3. 确保状态更新后再执行操作
          setTimeout(() => {
            this.$emit('tool-click', {
              name: tool.name,
              data: {
                attrs: option.value,
                text: option.label
              }
            })
          }, 0)
        } else {
          Message.warning('请将光标移至编辑器内')
        }
      } else {
        // 编辑器已有焦点，直接执行
        if (savedRange) {
          // 恢复选区
          const selection = window.getSelection()
          selection.removeAllRanges()
          selection.addRange(savedRange)
        }
        
        this.$emit('tool-click', {
          name: tool.name,
          data: {
            attrs: option.value,
            text: option.label
          }
        })
      }
    },

    isActive(toolName) {
      return this.store.state.ssmlEditor.activePlugins.includes(toolName)
    },

    getIconSrc(icon) {
      return require(`@/assets/img/voiceComposeCustom/${icon}`)
    }
  }
}
</script>

<style lang="less" scoped>
.operators {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 1px 14px 1px;
  border: 1px solid rgba(220, 220, 220, 0.5);
  border-radius: 4px 4px 0px 0px;
  border-bottom: 1px solid #DCDFE6;
  
  .operator-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 62px;
    height: 46px;
    cursor: pointer;
    margin-right: 4px;
    border-radius: 4px;
    
    &:hover {
      background: rgba(185, 195, 195, 0.15);
    }
    
    // &.active {
    //   background: #F5F7FA;
    //   color: #409EFF;
    // }
    
    img {
      width: 20px;
      height: 20px;
      margin-bottom: 6px;
    }
    
    span {
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 500;
      font-size: 12px;
      color: #050f0f;
      line-height: 17px;
    }
  }

  .sep {
    width: 1px;
    height: 32px;
    background: #DCDCDC;
    margin: 0 9px 0 5px;
  }
}
</style>
<style lang="less">
.ssml-dropdown-menu {
  &.el-dropdown-menu {
    padding: 0 !important;
  }
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: rgba(65, 180, 140, 0.1) !important;
    color: #41B48C !important;
  }
  .el-dropdown-menu__item {
    font-family: PingFang-SC, PingFang-SC;
    font-weight: 500;
    font-size: 13px;
    color: #323B4B;
    line-height: 18px;
    padding: 6px 14px;
  }
}
</style>